import React from "react";
import "./Group222.css";

function Group222(props) {
  const { className } = props;

  return (
    <div className={`group-222-3 ${className || ""}`}>
      <div className="view-gallery poppins-medium-white-10px">View Gallery</div>
    </div>
  );
}

export default Group222;
